var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomotiveServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7451 0.248352C23.1351 0.248352 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C78.3551 100.248 100.745 77.8584 100.745 50.2484C100.745 22.6384 78.3551 0.248352 50.7451 0.248352ZM50.7451 86.2984C30.8351 86.2984 14.6951 70.1584 14.6951 50.2484C14.6951 30.3384 30.8351 14.1984 50.7451 14.1984C70.6551 14.1984 86.7952 30.3384 86.7952 50.2484C86.7952 70.1584 70.6551 86.2984 50.7451 86.2984Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7451 16.8484C32.3251 16.8484 17.3451 31.8284 17.3451 50.2484C17.3451 68.6684 32.3251 83.6484 50.7451 83.6484C69.1651 83.6484 84.1451 68.6684 84.1451 50.2484C84.1451 31.8284 69.1651 16.8484 50.7451 16.8484ZM76.1351 37.5384L63.8651 40.6784C59.9351 41.6784 56.0651 38.8684 55.8051 34.8184L54.9951 22.1684C64.2651 23.5684 72.0751 29.4584 76.1351 37.5384ZM45.1651 56.3484C46.0251 56.3484 46.7151 57.0384 46.7151 57.8984C46.7151 58.7584 46.0151 59.4483 45.1651 59.4483C44.3151 59.4483 43.6151 58.7584 43.6151 57.8984C43.6151 57.0384 44.3051 56.3484 45.1651 56.3484ZM42.0551 49.0384C41.1951 49.0384 40.5051 48.3484 40.5051 47.4884C40.5051 46.6284 41.1951 45.9384 42.0551 45.9384C42.9151 45.9384 43.6051 46.6284 43.6051 47.4884C43.6051 48.3484 42.9051 49.0384 42.0551 49.0384ZM46.3351 50.2484C46.3351 47.8084 48.3051 45.8384 50.7451 45.8384C53.1851 45.8384 55.1551 47.8084 55.1551 50.2484C55.1551 52.6884 53.1851 54.6583 50.7451 54.6583C48.3051 54.6583 46.3351 52.6884 46.3351 50.2484ZM52.4551 41.1084C52.4551 41.9684 51.7551 42.6584 50.9051 42.6584C50.0551 42.6584 49.3551 41.9684 49.3551 41.1084C49.3551 40.2484 50.0451 39.5584 50.9051 39.5584C51.7651 39.5584 52.4551 40.2584 52.4551 41.1084ZM56.5951 56.0883C57.4551 56.0883 58.1451 56.7784 58.1451 57.6384C58.1451 58.4984 57.4551 59.1883 56.5951 59.1883C55.7351 59.1883 55.0451 58.4984 55.0451 57.6384C55.0451 56.7784 55.7451 56.0883 56.5951 56.0883ZM57.8851 47.4284C57.8851 46.5684 58.5851 45.8784 59.4351 45.8784C60.2851 45.8784 60.9851 46.5784 60.9851 47.4284C60.9851 48.2784 60.2951 48.9783 59.4351 48.9783C58.5751 48.9783 57.8851 48.2884 57.8851 47.4284ZM46.4951 22.1684L45.6851 34.8184C45.4251 38.8684 41.5551 41.6784 37.6251 40.6784L25.3551 37.5384C29.4251 29.4584 37.2251 23.5584 46.4951 22.1684ZM22.3451 50.2484C22.3451 48.6684 22.4851 47.1184 22.7351 45.6084L34.5151 50.2884C38.2851 51.7884 39.7651 56.3383 37.5951 59.7583L30.8251 70.4483C25.6051 65.2983 22.3551 58.1384 22.3551 50.2383L22.3451 50.2484ZM37.6851 75.4584L45.7651 65.7084C48.3551 62.5884 53.1351 62.5884 55.7251 65.7084L63.8051 75.4584C59.8951 77.4984 55.4451 78.6584 50.7451 78.6584C46.0451 78.6584 41.5951 77.4984 37.6851 75.4584ZM70.6751 70.4584L63.9051 59.7683C61.7351 56.3383 63.2151 51.7883 66.9851 50.2983L78.7651 45.6184C79.0151 47.1284 79.1552 48.6783 79.1552 50.2583C79.1552 58.1583 75.9051 65.3084 70.6852 70.4684L70.6751 70.4584Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1710",
    x: 0.0000118613,
    y: -0.0000265539,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1710",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1710",
    result: "effect3_innerShadow_4857_1710"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomotiveServices);
export default __webpack_public_path__ + "static/media/AutomotiveServices.fdd4b48458b247fcba4b3567fd7df542.svg";
export { ForwardRef as ReactComponent };